module.exports = __webpack_public_path__ + "img/image2.0e428824.png";